import "./v1/hero-text.js";
import "./v2/hero-text.js";